import { useEffect } from "react";
import "../../../styles/customScrollbar.css";

/**
 * Puts the app's own scrollbar on the public form pages.
 *
 * The dashboard scrolls inside a panel, so it wears `.custom-scrollbar-overlay`
 * on the element that scrolls. These pages have no such element: the shell is
 * deliberately free to grow past the viewport, which is what gives a field
 * somewhere to go when a phone keyboard covers it, so what scrolls is the
 * document. A class on `<html>` is the only way to reach that thumb, and it is
 * taken off again on the way out so nothing else in the app is touched.
 *
 * Called by `PublicFormShell`, which every screen of both forms is drawn in.
 */
const useFormPageScrollbar = () => {
  useEffect(() => {
    const root = document.documentElement;
    root.classList.add("form-page-scroll");
    return () => root.classList.remove("form-page-scroll");
  }, []);
};

export default useFormPageScrollbar;
